module.exports = "<!--<div [hidden]=\"showLoader\">-->\n<app-error-toast></app-error-toast>\n\n<router-outlet></router-outlet>\n<!--</div>-->\n\n<!--<ng-container *ngIf=\"showLoader\">-->\n  <!--<div class=\"spinner-container\">-->\n    <!--<div class=\"spinner\">LOADING...</div>-->\n  <!--</div>-->\n<!--</ng-container>-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main